import { Typography, CircularProgress } from '@mui/material';

export const DeterministicProcessingState = () => (
  <Typography
    variant="body2"
    color="text.disabled"
    aria-busy="true"
    aria-label="Processing file"
    sx={{ mt: 0.625, display: 'flex', alignItems: 'center', gap: 0.625 }}
  >
    <CircularProgress size={14} color="inherit" />
    Processing file...
  </Typography>
);
